import { render } from "./ReceivingPayments.vue?vue&type=template&id=79a33c25&scoped=true"
import script from "./ReceivingPayments.vue?vue&type=script&lang=js"
export * from "./ReceivingPayments.vue?vue&type=script&lang=js"

import "./ReceivingPayments.vue?vue&type=style&index=0&id=79a33c25&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a33c25"]])

export default __exports__